export type SanctionReason =
  | 'email_missing'
  | 'wrong_category'
  | 'not_following'
  | 'follows_bot'
  | 'insufficient_posts'
  | 'appeal_rejected';

export type SanctionItem = {
  id: string;
  reason: SanctionReason;
  eur: number;
  creators_deducted: number;
  top_tier_price: number;
  created_at: string;
  notes: string;
};

export type SanctionsPending = {
  total: number;
  items: SanctionItem[];
};

export const SANCTION_REASON_LABEL: Record<SanctionReason, string> = {
  email_missing: 'Tiene email y no lo pones',
  wrong_category: 'Categoría incorrecta',
  not_following: '"No sigue" y sí sigue a @ernestdift',
  follows_bot: 'Hace follow a @the3333games',
  insufficient_posts: 'Menos de 10 publicaciones coherentes',
  appeal_rejected: 'Apelación de IA rechazada',
};

// Motivos que el admin puede elegir manualmente en "Sancionar".
// appeal_rejected se aplica solo automáticamente al rechazar una apelación,
// así que se excluye del selector manual.
export const MANUAL_SANCTION_REASONS: SanctionReason[] = [
  'email_missing',
  'wrong_category',
  'not_following',
  'follows_bot',
  'insufficient_posts',
];
